var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.40814 0.40814C0.733577 0.0827033 1.26121 0.0827033 1.58665 0.40814L5.9974 4.81889L10.4081 0.408141C10.7336 0.0827038 11.2612 0.0827038 11.5867 0.408141C11.9121 0.733578 11.9121 1.26122 11.5867 1.58665L7.17591 5.9974L11.5866 10.4081C11.9121 10.7336 11.9121 11.2612 11.5866 11.5867C11.2612 11.9121 10.7336 11.9121 10.4081 11.5867L5.9974 7.17591L1.58665 11.5867C1.26121 11.9121 0.733577 11.9121 0.40814 11.5867C0.0827033 11.2612 0.0827033 10.7336 0.40814 10.4081L4.81888 5.9974L0.40814 1.58665C0.0827033 1.26121 0.0827033 0.733577 0.40814 0.40814Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCross);
export default __webpack_public_path__ + "static/media/ClearCross.1376646fe34f6f264e34af317a89835b.svg";
export { ForwardRef as ReactComponent };